var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 981 981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#442114;}.cls-2{fill:#10283a;}.cls-3{fill:#173856;}.cls-4{fill:#fbbcaa;}.cls-5{fill:#20456e;}.cls-6{fill:#639;}.cls-7{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bas frame 2 f") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bas_f_2",
    "data-name": "bas f 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1006.75,647.41c0-2.87.25-19.41.25-21.41-34,0-81,4-90.86,38.25-46.49,20.4-84,60.11-92.23,123.75C822,830,829,827,839,830c8.21,33.38,28.41,67,46,90,8.18,10.67,22,4.49,30,12,14.46,13.6,24,3.77,39,11,31.06,15,38.28,24.26,52,23C1006,927.2,1006.75,731,1006.75,647.41Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1006,647.41c0-2.87-.25-19.41-.25-21.41,34,0,81,4,90.87,38.25,46.49,20.4,84,60.11,92.22,123.75,1.91,42-5.09,39-15.09,42-8.21,33.38-38.16,70-55.75,93-8.18,10.67-27,11.49-35,19-14.46,13.6-15,8.77-30,16-31.06,15-33.28,14.26-47,13Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1016,1408v70c0,26.91,67,26.91,67,0v-74Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1007,1248l-12,289c-.17,3.41-78.17-.59-78-4V1252Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1098,1252l-7,185c0,34.27-80,34.27-80,0l-10-99,5.75-86Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M877,1192.8c5.12-18.42,62.12-6.06,57,12.37,0,0-3,33.56-37,28.26S877,1192.8,877,1192.8Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M933,1019.54c-22.58.39-40.5,9.34-49,35.46l-12,135c0,36,58,40,58,13Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M916.82,1252.5v-203s0-50,90.59-50,90.59,40,90.59,40v213Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 400,
    y: 633,
    width: 181,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1004,1033c-22.07-3.49-40.42-10.38-50-25.29,4.28-6.19,9.41-11.82,25-10.6l15-.11,4.51,2.79C957,1008.23,979.6,1020.56,1004,1033Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1012,1032.89c22.07-3.49,40.42-10.39,50-25.29-4.28-6.19-9.41-11.83-25-10.6l-15-.11-4.51,2.79C1059.05,1008.12,1036.4,1020.45,1012,1032.89Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1199.41,836.19c-14-20.19-23.41-3.79-23.41-5.69a169,169,0,0,0-168.59-169H1007a169,169,0,0,0-168.59,169c0,1.9-9.41-14.5-23.41,5.69-7.72,11.13-8.89,57.77,9,76.81,14.55,15.49,33,24,45.38,15A168.78,168.78,0,0,0,1007,999.49h.41A168.78,168.78,0,0,0,1145,928c12.38,9,30.83.45,45.38-15C1208.3,894,1207.13,847.32,1199.41,836.19Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1083,1016.54c22.58.39,40.5,9.34,49,35.46l28,148c-14,24-49,33-62,18Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1150.75,1209c-1.24-8.77-45.49,3.82-44.82,11,0,0,2.36,29.89,29.1,25.17S1150.75,1209,1150.75,1209Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1188.84,788c-13.29-102.33-102.07-142.78-182.46-140.6C926,645.22,837.21,685.67,823.91,788,822,830,829,827,839,830c6,13,15,13,20,10,.63-11.94.33-22.08,5-41,7.45-3.34,18.27-11.35,24-19,4.29-5.52,11.11-29.76,21-32,37.8-8.57,82.42-10.92,97-10.88h.75c14.58,0,59.2,2.31,97,10.88,9.89,2.24,16.71,26.48,21,32,5.74,7.65,16.55,15.66,24,19,4.68,18.92,4.38,29.06,5,41,5,3,14,3,20-10C1183.75,827,1190.75,830,1188.84,788Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M921,1540v33h67v-34C986.3,1510.55,919.3,1511.55,921,1540Z",
    transform: "translate(-517 -611)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cadre_invisible",
    "data-name": "cadre invisible"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 981,
    height: 981
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomFrame2);
export default __webpack_public_path__ + "static/media/bottom_frame_2.ddcb0083b6f1468d89fe154a78404e11.svg";
export { ForwardRef as ReactComponent };